'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domElement = require('../../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubtreeLayer = function (_React$Component) {
  _inherits(SubtreeLayer, _React$Component);

  function SubtreeLayer() {
    _classCallCheck(this, SubtreeLayer);

    return _possibleConstructorReturn(this, (SubtreeLayer.__proto__ || Object.getPrototypeOf(SubtreeLayer)).apply(this, arguments));
  }

  _createClass(SubtreeLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateSubtree();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateSubtree();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props = this.props,
          element = _props.element,
          renderTree = _props.renderTree;


      var closeTransitionTree = renderTree(null);
      if (closeTransitionTree) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, closeTransitionTree, element);
      }
    }
  }, {
    key: 'updateSubtree',
    value: function updateSubtree() {
      var _props2 = this.props,
          children = _props2.children,
          element = _props2.element,
          renderTree = _props2.renderTree;

      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, renderTree(children), element);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return SubtreeLayer;
}(_react2.default.Component);

SubtreeLayer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  element: _domElement2.default.isRequired,
  renderTree: _react.PropTypes.func.isRequired
};

exports.default = SubtreeLayer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/layer/internal/SubtreeLayer.js
// module id = 438
// module chunks = 3 4 5